(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rohl-studio"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRohlSlider(sectionRoot) {
    if (!sectionRoot) return;

    var slider = sectionRoot.querySelector('[data-rs-slider]');
    if (!slider) return;

    var track = slider.querySelector('[data-rs-track]');
    var btnPrev = slider.querySelector('[data-rs-prev]');
    var btnNext = slider.querySelector('[data-rs-next]');
    if (!track || !btnPrev || !btnNext) return;

    function getStep() {
      // step = first image width + gap (3rem)
      var firstImg = track.querySelector('.rs-slide__img');
      if (!firstImg) return 0;

      var imgWidth = firstImg.getBoundingClientRect().width;

      var styles = window.getComputedStyle(track);
      var gapValue = styles.gap || styles.columnGap || '0px';
      var gap = parseFloat(gapValue) || 0;

      return imgWidth + gap;
    }

    function scrollByStep(direction) {
      var step = getStep();
      if (!step) return;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    btnPrev.addEventListener('click', function () {
      scrollByStep(-1);
    });

    btnNext.addEventListener('click', function () {
      scrollByStep(1);
    });

    // Keyboard support when the track is focused
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollByStep(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollByStep(-1);
      } else if (e.key === 'PageDown') {
        e.preventDefault();
        track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
      } else if (e.key === 'PageUp') {
        e.preventDefault();
        track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
      } else if (e.key === 'Home') {
        e.preventDefault();
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (e.key === 'End') {
        e.preventDefault();
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      }
    });

    function updateArrowVisibility() {
      var maxScrollLeft = track.scrollWidth - track.clientWidth;

      if (track.scrollLeft <= 2) {
        btnPrev.classList.add('is-hidden');
      } else {
        btnPrev.classList.remove('is-hidden');
      }

      if (track.scrollLeft >= maxScrollLeft - 2) {
        btnNext.classList.add('is-hidden');
      } else {
        btnNext.classList.remove('is-hidden');
      }
    }

    track.addEventListener('scroll', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    // initial state
    updateArrowVisibility();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      initRohlSlider(section);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initRohlSlider(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-dropdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initServicesAccordion(root) {
    if (!root) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-accordion-item]'));

    function closeItem(item) {
      var btn = item.querySelector('.services-accordion__toggle');
      var panel = item.querySelector('.services-accordion__panel');
      if (!btn || !panel) return;

      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    function openItem(item) {
      var btn = item.querySelector('.services-accordion__toggle');
      var panel = item.querySelector('.services-accordion__panel');
      if (!btn || !panel) return;

      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.services-accordion__toggle');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');

        // Close all others
        items.forEach(function (other) {
          if (other !== item) closeItem(other);
        });

        // Toggle clicked
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-services-accordion]').forEach(function (root) {
      initServicesAccordion(root);
    });
  });

  // Theme editor support (re-init when Shopify re-renders a section)
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-services-accordion]');
    initServicesAccordion(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
